import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {{ label: string, to?: string }[]} [props.breadcrumbs]
 * @param {React.ReactNode} [props.children] - ações à direita (botões)
 */
const PageHeader = ({ title, description, breadcrumbs, children }) => {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
      <div className="min-w-0 flex-1">
        {breadcrumbs?.length > 0 && (
          <nav className="mb-2 flex flex-wrap items-center gap-1 text-sm text-gray-500" aria-label="Breadcrumb">
            {breadcrumbs.map((crumb, i) => (
              <span key={`${crumb.label}-${i}`} className="flex items-center gap-1">
                {i > 0 && <ChevronRight className="h-4 w-4 shrink-0 text-gray-400" aria-hidden />}
                {crumb.to && i < breadcrumbs.length - 1 ? (
                  <Link to={crumb.to} className="hover:text-primary-700">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className={i === breadcrumbs.length - 1 ? 'font-medium text-gray-700' : ''}>
                    {crumb.label}
                  </span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className="text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">{title}</h1>
        {description && (
          <p className="mt-1 text-gray-600">{description}</p>
        )}
      </div>
      {children && (
        <div className="flex shrink-0 flex-wrap items-center gap-2 sm:justify-end">
          {children}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
